import { workMainProxy, workPsnlProxy, configProxy } from './index';
// proxy/work/main/1.0/

/* [ 메인 ] */
// 개인근무정보조회
function getPsnlWorkInfo() {
  return workMainProxy.get('psnl/info');
}

// EHR 출퇴근체크
function checkTimeCard(params) {
  return workMainProxy.get('timecard/check', { params });
}

// 개인별휴가현황조회
function getPsnlHolidayList(params) {
  return workPsnlProxy.get('holiday/1.0/list', { params });
}

// LBS 정보 조회
function getLBSInfo() {
  return configProxy.get('tagagInfoMgr/lbs');
}

export { getPsnlWorkInfo, checkTimeCard, getPsnlHolidayList, getLBSInfo };
